<template>
  <b-card class="border border-primary table-responsive" no-body>
    <b-card-header class="bg-primary pt-8">
      <b-card-title>
        <div class="d-flex justify-content-between align-items-center">
          <div style="text-align: start">
            <p class="mb-2">{{ title }}</p>
            <p class="text-muted font-size-sm">
              Total: {{ toCurrency(report.total) }}
            </p>
          </div>
          <b-button
            variant="secondary-outline"
            size="sm"
            @click="isExpanded = !isExpanded"
          >
            {{ isExpanded ? "Recolher" : "Expandir" }}
            <b-icon
              :icon="isExpanded ? 'chevron-up' : 'chevron-down'"
              class="ml-1"
            ></b-icon>
          </b-button>
        </div>
      </b-card-title>
    </b-card-header>

    <b-collapse :visible="isExpanded">
      <v-card-text>
        <div class="table-responsive">
          <PlanAccountTable :report="report" />
        </div>
      </v-card-text>
    </b-collapse>
  </b-card>
</template>

<script>
import PlanAccountTable from "./PlanAccountTable.vue";

export default {
  name: "RelatorioDRECard",
  props: {
    title: {
      type: String,
      required: true,
    },
    report: {
      type: Object,
      required: true,
    },
  },
  components: {
    PlanAccountTable,
  },
  data() {
    return {
      isExpanded: true,
    };
  },
  methods: {
    toCurrency(value, decimals = 2) {
      return new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
        minimumFractionDigits: decimals,
      }).format(value || 0);
    },
  },
};
</script>
